import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./reducers/user-slice";
import roomReducer from "./reducers/room-slice";
import { APP_ENV } from "../common";

const store = configureStore({
  reducer: {
    user: userReducer,
    room: roomReducer,
  },
  devTools: APP_ENV === "prod" ? false : true,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
